import api from "./index";

// Get User
export const getUserProfile = async () => {
  return api.get("/user/profile");
};

// Update user profile
export const updateUserProfile = async (
  name: string,
  email: string,
  phone: string,
  DOB: string
) => {
  return api.post("/user/update-profile", {
    name,
    email,
    phone,
    DOB,
  });
};

// upload profile
export const uploadProfilePicture = async (file: File) => {
  const formData = new FormData();
  // API expects field name `profilePictureUrl` (string(binary))
  formData.append("profilePictureUrl", file);

  return api.post("/user/upload-profile-picture", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// update password
export const updatePassword = async (
  oldPassword: string,
  newPassword: string
) => {
  return api.post("/user/update-password", {
    oldPassword,
    newPassword,
  });
};
